import { snakeCase } from 'lodash'
import { baseReportUrl } from 'config'
import { createPost } from 'helpers/api'

const entityName = 'taskManager'
const ENTITY_NAME = snakeCase(entityName).toUpperCase()

export default {
  runNow: (taskId) => ({
    type: `${ENTITY_NAME}_RUN_NOW`,
    payload: createPost(entityName, {
      basePath: 'report',
      baseUrl: baseReportUrl,
      action: 'runNow',
    })({ taskId }),
  }),
}
